import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import playImg from '../../../images/aiReport/play.png';
import pauseImg from '../../../images/aiReport/pause.png';
import playingIcon from '../../../images/aiReport/playing-icon.png';

const ResultApp = ({data = {}, closeVideo}, ref) => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [voiceList, setVoiceList] = useState([]);

    useImperativeHandle(ref, () => ({
        closeAudio: ()=> {
            audioRef.current && audioRef.current.pause();
            setIsPlaying(false);
        }
    }))

    useEffect(()=>{
        // 是否使用ai的语言分析结果
        let aiLanAnalysisEnReport = data.aiLanAnalysisEnReport;
        let aiLanAnalysisCnReport = data.aiLanAnalysisCnReport;
        let aiLanAnalysisReports = data.aiLanAnalysisReports || [];
        let _list = [];
        if(aiLanAnalysisReports){
            aiLanAnalysisReports.forEach((val, key) => {
                _list.push({
                    type: val.language || key,
                    typeName: val.langDesc,
                    voiceUrl: val.audioUrl,
                    voiceTime: `${val.duration || 0}s`,
                    accuracyScore: val.accuracyScore || 0,
                    expressionScore: val.expressionScore || 0,
                    richnessScore: val.richnessScore || 0,
                    logicalScore: val.logicalScore || 0,
                    statusName: val.levelDesc || '',
                    statusContent: val.levelMark || '',
                    statusClass: filterClass(val.levelDesc),
                })
            })
        }
        // if(aiLanAnalysisCnReport){
        //     _list.push({
        //         type: 1,
        //         typeName: '普通话水平',
        //         voiceUrl: aiLanAnalysisCnReport.audioUrl,
        //         voiceTime: `${aiLanAnalysisCnReport.duration || 0}s`,
        //         accuracyScore: aiLanAnalysisCnReport.accuracyScore || 0,
        //         expressionScore: aiLanAnalysisCnReport.expressionScore || 0,
        //         richnessScore: aiLanAnalysisCnReport.richnessScore || 0,
        //         logicalScore: aiLanAnalysisCnReport.logicalScore || 0,
        //         statusName: aiLanAnalysisCnReport.levelDesc || '',
        //         statusContent: aiLanAnalysisCnReport.levelMark || '',
        //         statusClass: filterClass(aiLanAnalysisCnReport.levelDesc),
        //     })
        // }
        // if(aiLanAnalysisEnReport){
        //     _list.push({
        //         type: 2,
        //         typeName: '英语水平',
        //         voiceUrl: aiLanAnalysisEnReport.audioUrl,
        //         voiceTime: `${aiLanAnalysisEnReport.duration || 0}s`,
        //         accuracyScore: aiLanAnalysisEnReport.accuracyScore || 0,
        //         expressionScore: aiLanAnalysisEnReport.expressionScore || 0,
        //         richnessScore: aiLanAnalysisEnReport.richnessScore || 0,
        //         logicalScore: aiLanAnalysisEnReport.logicalScore || 0,
        //         statusName: aiLanAnalysisEnReport.levelDesc || '',
        //         statusContent: aiLanAnalysisEnReport.levelMark || '',
        //         statusClass: filterClass(aiLanAnalysisEnReport.levelDesc),
        //     })
        // }
        setVoiceList(_list);
    },[data])

    const filterClass = (level) => {
        switch (level) {
            case '好':
                return 'c52C41B' ;
            case '一般':
                return 'fdae21';
            case '不标准':
                return 'ff4d4f';
            default:
                return '';
        }
    };

    const changeAudio = ()=> {
        if(audioRef.current){
            isPlaying
                ? audioRef.current.pause()
                : audioRef.current.play().catch(() => setIsPlaying(false))

            // 改变isPlaying的状态
            setIsPlaying(!isPlaying)
        }
        closeVideo();
    };

    if(voiceList && voiceList.length){
        return (
            <div className="voice-wrap">
                <div className="readingTitleWrap">
                    <div className="readingTitleLeft">
                        <div className="readingTitleLeftIcon">
                            <span></span>
                            <span></span>
                        </div>
                        <span>语音分析</span>
                        <div className="readingTitleTab active1">
                            <i></i>
                            <p>准确度</p>
                        </div>
                        <div className="readingTitleTab active">
                            <i></i>
                            <p>表达流畅度</p>
                        </div>
                        <div className="readingTitleTab">
                            <i></i>
                            <p>词汇丰富度</p>
                        </div>
                        <div className="readingTitleTab active2">
                            <i></i>
                            <p>逻辑严谨性</p>
                        </div>
                    </div>
                    <div className="readingTitleRight">

                    </div>
                </div>
                {/*内容部分*/}
                <div className="result-padding">
                    {
                        voiceList.map((item, key) => {
                            return (
                                <div className="voice-item" key={key}>
                                    <div className="voice-item-left">
                                        <div className="voice-item-typeName">
                                            <span>{item.typeName}</span>
                                            {item.voiceUrl && <div className="voice-item-url-wrap">
                                                <img src={isPlaying ? pauseImg : playImg} className="voice-item-play" onClick={changeAudio}/>
                                                <img src={playingIcon} className="voice-item-playing"/>
                                                <div className="voice-item-play-time">{item.voiceTime}</div>
                                            </div>}
                                        </div>
                                        <div className="voice-item-progress first">
                                            <div className="voice-item-progress-li">
                                                <p></p>
                                                <p style={{width: 310*(item.accuracyScore/10) >= 310 ? 310 : 310*(item.accuracyScore/10)}}></p>
                                            </div>
                                            <span className="voice-item-fluency">{item.accuracyScore}分</span>
                                        </div>
                                        <div className="voice-item-progress two">
                                            <div className="voice-item-progress-li">
                                                <p></p>
                                                <p style={{width: 310*(item.expressionScore/10) >= 310 ? 310 : 310*(item.expressionScore/10)}}></p>
                                            </div>
                                            <span className="voice-item-fluency">{item.expressionScore}分</span>
                                        </div>
                                        <div className="voice-item-progress three">
                                            <div className="voice-item-progress-li">
                                                <p></p>
                                                <p style={{width: 310*(item.richnessScore/10) >= 310 ? 310 : 310*(item.richnessScore/10)}}></p>
                                            </div>
                                            <span className="voice-item-fluency">{item.richnessScore}分</span>
                                        </div>
                                        <div className="voice-item-progress four">
                                            <div className="voice-item-progress-li">
                                                <p></p>
                                                <p style={{width: 310*(item.logicalScore/10) >= 310 ? 310 : 310*(item.logicalScore/10)}}></p>
                                            </div>
                                            <span className="voice-item-fluency">{item.logicalScore}分</span>
                                        </div>
                                    </div>
                                    <div className="voice-item-right">
                                        <p className={item.statusClass}>{item.statusName}</p>
                                        <p>{item.statusContent}</p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>

                <div className="voice_audio">
                    <audio ref={audioRef} src={data.audioUrl} controls>
                        您的浏览器不支持 audio 标签。
                    </audio>
                </div>

            </div>
        );
    }else{
        return null;
    }
}

export default forwardRef(ResultApp);
